import { Action, ACTION_TYPE } from '@abiglobalhealth/go-types'

import { actionsRequest } from './utils'

export const setFulfillmentDelivery = async <T extends Action<ACTION_TYPE.SET_FULFILLMENT_DELIVERY>>(
  payload: T['payload']
): Promise<T['response']> => {
  const body = await actionsRequest<T>({
    payload,
    type: ACTION_TYPE.SET_FULFILLMENT_DELIVERY
  })

  if (!body?.data) throw new Error('No data')

  return body.data
}
